import { isFieldErrorResponse, useApiTradeV1DemandSignalsCreate } from 'api';
import { useNotification } from 'features';
import { UseFormReturn } from 'form';

import {
  DemandSignalFormInputValues,
  DemandSignalFormValues,
} from '../../schema/DemandSignalSchema/DemandSignalSchema';

export const useCreateDemandSignal = (
  form: UseFormReturn<DemandSignalFormInputValues, unknown, DemandSignalFormValues>
) => {
  const { setError } = form;
  const { open } = useNotification();
  return useApiTradeV1DemandSignalsCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            setError(field as keyof DemandSignalFormValues, { message: error.response.data[field] });
          });
        }
        if (error?.response?.data.non_field_errors) {
          open({
            description: error.response.data.non_field_errors.toString(),
            message: 'Error creating supply signal',
            type: 'error',
          });
        }
      },
      async onSuccess(demand_signal) {
        open({
          description: `Demand Signal created with ID: ${demand_signal.id}`,
          message: 'Demand Signal created',
          type: 'success',
        });
        form.reset();
      },
    },
  });
};
